import * as React from "react";
import { forwardRef } from "react";
const SvgIcFullscreen32 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "ic-fullscreen-32" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M24.9822 5.25H20.0001V2.75H29.2501V11H26.7501V7.01767L7.01777 26.75H11V29.25L2.75008 29.25L2.75 21L5.25 21L5.25004 24.9822L24.9822 5.25Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgIcFullscreen32);
export { ForwardRef as ReactComponent };
